import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c10090a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-signup-profile l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "会員情報登録", -1))
const _hoisted_4 = { class: "ha__sec ha-signup-profile__sec" }
const _hoisted_5 = { class: "ha-signup-profile__field-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkageSignupProgress = _resolveComponent("LinkageSignupProgress")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_LinkageSignupProgress, { signupProgress: "SignupConfirm" }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}